import IconButton from 'components/controls/buttons/icon-button';
import ZoomIn from 'assets/icons/zoom-in.svg';
import ZoomOut from 'assets/icons/zoom-out.svg';
import { useControls } from 'react-zoom-pan-pinch';
import styles from 'components/collection/modal-viewer/controls/controls.module.scss';

export const ZoomControls = ({ isDisabled }: { isDisabled?: boolean }) => {
	const { zoomIn, zoomOut } = useControls();
	return (
		<div className={styles.buttonGroup}>
			<IconButton
				label="Zoom in"
				disabled={isDisabled}
				icon={<ZoomIn />}
				onClick={() => zoomIn()}
			/>
			<IconButton
				label="Zoom out"
				icon={<ZoomOut />}
				disabled={isDisabled}
				onClick={() => zoomOut()}
			/>
		</div>
	);
};

export default ZoomControls;
